import store from '@/store';
import { setErrorMessage } from '@actions/message/messageAction';
import { ResponseCode } from '@services/responseCode';
import { setWelcomeCustomerPhone } from '@actions/customizeWelcome/customizeWelcomeAction';
import { MemberInfoTypes } from '@actions/memberInfo/memberInfoTypes';
import { LiffActionType } from '@actions/liffLongin/liffType';
import WelcomeService from '../../services/welcome/welcomeService';
import { ModeActionType } from '../mode/modeTypes';
import { WelcomeActionType } from './welcomeTypes';

export const post: (storeUuid: string, data: any) => any = async (
  storeUuid,
  data
) => {
  try {
    const res = await WelcomeService.post(storeUuid, data);
    return await Promise.resolve(res.data);
  } catch (err) {
    console.log('axios error', err);
    throw err;
  }
};

const redirectToLinkExpired = () => {
  const url = `${process.env.REACT_APP_VERSION}/online/linkExpired`;
  window.location.href = url;
};

export const welcome: (
  storeUuid: string,
  mode?: string | null,
  phone?: string | null,
  customUuid?: string | null,
  redirectToken?: string | null
) => (dispatch) => Promise<void> =
  (storeUuid, mode, phone, customUuid, redirectToken) => async (dispatch) => {
    return WelcomeService.get(storeUuid, mode, phone, customUuid, redirectToken)
      .then((res) => {
        if (res?.data?.code === '40014') {
          redirectToLinkExpired();
        }
        dispatch({
          type: WelcomeActionType.GET_WELCOME,
          payload: res.data,
        });
        dispatch({
          type: ModeActionType.SET_PROJECT_NAME,
          payload: res.data.data.projectName,
        });
        // dispatch(
        //   setWelcomeCustomerPhone(res.data?.data?.orderVo?.table?.mobile)
        // );
        dispatch({
          type: MemberInfoTypes.SET_ENABLED,
          payload: res.data?.data?.webStoreVo?.onlineMemberEnable,
        });
        dispatch({
          type: LiffActionType.SET_LIFF,
          payload: res.data?.data?.orderVo?.lineUserId,
        });
      })
      .catch((err) => {
        dispatch({
          type: WelcomeActionType.GET_WELCOME,
          payload: err.data,
        });
        dispatch({
          type: ModeActionType.SET_PROJECT_NAME,
          payload: err.data.data.projectName,
        });
      });
  };

export const pickWelcome: (
  storeUuid: string,
  mode?: string | null,
  phone?: string | null,
  intl?: any
) => Promise<any> = (storeUuid, mode, phone, intl) => {
  return WelcomeService.get(storeUuid, mode, phone, null, null, (res) => {
    // 客製化 res處理
    const resData = res?.data;
    const welcomeData = resData?.data;

    store.dispatch({
      type: WelcomeActionType.GET_WELCOME,
      payload: resData,
    });
    store.dispatch({
      type: ModeActionType.SET_PROJECT_NAME,
      payload: resData?.projectName,
    });

    if (resData?.code !== ResponseCode.NO_ERROR) {
      if (!resData.code) return resData;

      let notOpenMessage = intl.formatMessage({
        id: `error.${resData.code}`,
      });
      let messageConfig;
      if (
        resData?.code === ResponseCode.HTY_STORE_NOT_OPEN ||
        resData?.code === ResponseCode.STORE_NOT_OPEN
      ) {
        notOpenMessage = intl.formatMessage(
          {
            id: `error.${resData.code}.msg`,
          },
          {
            startTime: welcomeData?.webStoreVo?.startTime,
            endTime: welcomeData?.webStoreVo?.endTime,
          }
        );

        messageConfig = {
          title: intl.formatMessage({
            id: 'welcome.pickup.timeremind.onlineTime.title',
          }),
          titleClass: 'justify-content-center',
          bodyClass: 'text-center',
        };
      }

      setErrorMessage(notOpenMessage, messageConfig);
    }

    return resData;
  });
};
